module.exports = __webpack_public_path__ + "static/media/proveoppgave-3.3cbacf09.mp3";